import jwt from 'jwt-decode'

// 是否為空值
function IsEmpty(val) {
    if (val === '' || val === undefined || val === null || val === false || val === '' || val === 'null') {
        return true
    } else {
        return false
    }
}

// 檢查是否為大陸站
function isCN() {
    let hostname = window.location.hostname
    return hostname.substr(hostname.length - 3) === '.cn'
}
// 取得UUID
function getUUID() {
    var d = Date.now()
    if (typeof performance !== 'undefined' && typeof performance.now === 'function') {
        d += performance.now()
    }
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = (d + Math.random() * 16) % 16 | 0
        d = Math.floor(d / 16)
        return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16)
    })
}
// JWT 解碼
function jwtDecode(val) {
    return jwt(val)
}

// 取得現在的語系
function getLang() {
    // 預設抓取瀏覽器的語系
    let lang = !IsEmpty(localStorage.getItem('lang')) ? localStorage.getItem('lang').toLowerCase() : ""

    if(lang == ""){
        let webLang = (navigator.language || navigator.browserLanguage).toLowerCase()
        switch (webLang) {
            case 'zh-tw':
                lang = 'tw'
                break;
            case 'zh-cn':
                lang = 'cn'
                break;
            case 'ja-jp':
                lang = 'jp'
                break;
            default:
                lang = 'en'
                break;
        }
    }

    // 預設為英文版
    if (lang !== 'tw' && lang !== 'cn' && lang !== 'jp') { lang = 'en' }

    return lang
}

export const jsFn = {
    isCN,
    IsEmpty,
    getUUID,
    jwtDecode,
    getLang
}
